<template>
    <div class="inner clearfix">
        <div class="xs-left fl">
            <div class="chart-con">
                <IconTitle :title="'Elsevier收录的中国期刊里外国作者占比'" :iconName="'people'"/>
                <div class="chart" id="chart1"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'Elsevier收录的各国期刊影响因子比较'" :iconName="'yinzi'"/>
                <div class="chart" id="chart2"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'Elsevier收录的中国期刊被各国引用量占比'" :iconName="'yinyong'"/>
                <div class="chart" id="chart3"></div>
            </div>
        </div>
        <div class="xs-center fl">
            <IconTitle :title="'Elsevier收录的各国期刊发文量比较'" class="lg" :iconName="'gnwyzb'"/>
            <div class="rink-con">
                <div class="estimate_header clearfix">
                    <span v-for="(item, index) in proportion.line" :key="index">
                        {{ item }}
                    </span>
                </div>
                <div class="estimate_body">
                    <div class="estimate_box">
                        <dl v-for="(item, index) in proportionData" :key="index">
                            <dd @click="choiceCountry(proportion.column[index],item)"
                                :class="item.checked ? 'active' : ''">
                                {{ proportion.column[index] }}
                            </dd>
                            <dd v-for="(v, i) in item" :key="i">
                                {{ v }}
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div class="xs-right fr">
            <div class="chart-con">
                <IconTitle :title="'SCI收录的我国科技人员在国内外期刊上发表论文的比重'" :iconName="'lunwen'"/>
                <div class="chart" id="chart4"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'EI收录的我国科技人员在国内外期刊上发表论文的比重'" :iconName="'zhishu'"/>
                <div class="chart" id="chart5"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'中文科技期刊刊登的科技论文篇数按机构类型分类'" :iconName="'wenben'"/>
                <div class="chart" id="chart6"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';
    import {
        getAuthorProportion,
        getBrokenLine,
        getPaperProportion,
        getOrganizationType,
        getPostProportion} from "@/assets/scripts/api/xsdt";
    const PIE_COLOR = ['#344ED5', '#0179FF', '#01CDFF', '#30D070', '#FC058F'];
    const BAR_COLOR = ['#FC058F','#05C1FC'];
    const LINE_COLOR = '#B6C8FF';
    const LINE_COLOR1 = '#3046C2';

    export default {
        name: 'GuoNeiQiKan',
        components: {
            IconTitle
        },
        data() {
            return {
                brokenParam: {
                    first_name: '中国',
                    second_name: '瑞士'
                },
                brokenArr: ['中国','瑞士'],
                organizationTotal: 0,
                proportion: [],
                proportionData: [],
                choseName: true
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.getAuthorProportion();
                this.getBrokenLine();
                this.getPostProportion();
                getPaperProportion(1).then((response) => {
                    let data = response.data.list,
                        column = response.data.column,
                        title = response.data.tile;

                    this.initChart4(data,column,title);

                })
                getPaperProportion(2).then((response) => {
                    let data = response.data.list,
                        column = response.data.column,
                        title = response.data.tile;

                    this.initChart5(data,column,title);

                })
                getOrganizationType().then((response) => {
                    let data = response.data;

                    data.forEach((item) => {
                        this.organizationTotal += parseInt(item.value);
                    });
                    this.initChart6(data);
                })

            },
            choiceCountry(name) {
                const hasIdx = this.brokenArr.indexOf(name);

                if (hasIdx >= 0) {
                    this.brokenArr.splice(hasIdx, 1);

                } else {

                    if (this.brokenArr.length >= 2) {
                        this.brokenArr.splice(0, 1);
                    }
                    this.brokenArr.push(name);
                }

                this.brokenParam.first_name = this.brokenArr[0];
                this.brokenParam.second_name = this.brokenArr[1];

                this.proportionData = [];
                let propData = this.proportion.data;

                for (let i in this.proportion.column){
                    const name = this.proportion.column[i];
                    propData[i].checked = false;
                    propData[i].name = name;

                    if(this.brokenParam.first_name == name || this.brokenParam.second_name == name) {
                        propData[i].checked = true;
                    }
                }

                this.proportionData = propData;
                this.getBrokenLine();
            },
            getPostProportion() {
                getPostProportion().then(({data}) => {
                    let propData = data.data;

                    for (let i in data.column){
                        const name = data.column[i];
                        propData[i].checked = false;
                        propData[i].name = name;

                        if(this.brokenParam.first_name == name || this.brokenParam.second_name == name) {
                            propData[i].checked = true;
                        }
                    }

                    this.proportion = data;
                    this.proportionData = propData;
                })
            },
            initLineCharts(data,column,title) {
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: [{
                                   name: title[0],
                                   textStyle: {
                                       color: BAR_COLOR[0]
                                   }
                               },
                               {
                                   name: title[1],
                                   textStyle: {
                                       color:BAR_COLOR[1]
                                   }
                               }],
                        left: 'center',
                        bottom: '3%'
                    },
                    grid: {
                        top: 'middle',
                        left: 0,
                        right: 0,
                        height: '70%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: LINE_COLOR,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: LINE_COLOR1
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: column
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: LINE_COLOR,
                                fontSize: 14
                            }
                        },
                    },
                    series: [{
                                 name: title[0],
                                 type: 'line',
                                 data: data[0],
                                 color: BAR_COLOR[0],
                                 lineStyle: {
                                     normal: {
                                         width: 2,
                                         color: BAR_COLOR[0]
                                     }
                                 },
                                 itemStyle: {
                                     color:BAR_COLOR[0],
                                     normal: {
                                         color: BAR_COLOR[0],
                                         borderWidth: 6,
                                         borderColor: BAR_COLOR[0]
                                     }
                                 },
                                 smooth: true
                             },
                             {
                                 name: title[1],
                                 type: 'line',
                                 data: data[1],
                                 color: BAR_COLOR[1],
                                 lineStyle: {
                                     normal: {
                                         width: 2,
                                         color: BAR_COLOR[1]
                                     }
                                 },
                                 itemStyle: {
                                     normal: {
                                         color: BAR_COLOR[1],
                                         borderWidth: 6,
                                         borderColor: BAR_COLOR[1]
                                     }
                                 },
                                 smooth: true
                             }]
                };

                return option;
            },
            getAuthorProportion() {
                getAuthorProportion().then((response) => {
                    let column = response.data.column,
                        list = response.data.list;

                    this.initChart1(column,list);
                })
            },
            getBrokenLine() {
                getBrokenLine(this.brokenParam).then((response) => {
                    let data = response.data.factor.list,
                        column = response.data.factor.column,
                        title = response.data.factor.title,
                        quoteData = response.data.quote.list,
                        quoteColumn = response.data.quote.column,
                        quoteTitle = response.data.quote.title;

                    this.initChart2(data,column,title);
                    this.initChart3(quoteData,quoteColumn,quoteTitle);
                })
            },
            initChart1(column,list) {
                const chart = echarts.init(document.getElementById("chart1"));

                const option = {
                    barWidth: 20,
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        backgroundColor: '#fff',
                        extraCssText: 'box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.2);',
                        textStyle: {
                            color: "#333"
                        }
                    },
                    grid: {
                        x: 0,
                        top: '20%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: LINE_COLOR,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: LINE_COLOR1
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: column
                    },
                    yAxis: {
                        boundaryGap: true,
                        splitLine: {
                            lineStyle: {
                                color: LINE_COLOR1,
                                type: 'dotted'
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: LINE_COLOR,
                                fontSize: 14
                            }
                        },
                        splitArea: this.splitArrOpts
                    },
                    series: [{
                        type: 'bar',
                        name: "外国作者占比",
                        itemStyle: {
                            normal: {
                                show: true,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#01CDFF'
                                }, {
                                    offset: 0.9,
                                    color: '#344ED5'
                                }])
                            }
                        },
                        data: list
                    }]
                };
                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2(data,column,title) {
                const chart = echarts.init(document.getElementById("chart2"));
                chart.setOption(this.initLineCharts(data,column,title), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data,column,title) {
                const chart = echarts.init(document.getElementById("chart3"));
                chart.setOption(this.initLineCharts(data,column,title), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4(data,column,title) {
                const chart = echarts.init(document.getElementById("chart4"));
                chart.setOption(this.initLineCharts(data,column,title), true);
                chart.resize();
                this.$winResize(chart.resize);

            },
            initChart5(data,column,title) {
                const chart = echarts.init(document.getElementById("chart5"));
                chart.setOption(this.initLineCharts(data,column,title), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart6(data){
                let organizationTotal = this.organizationTotal;
                const chart = echarts.init(document.getElementById("chart6"));
                const option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        right: 0,
                        top: '10%',
                        textStyle:{
                            color: LINE_COLOR,
                            fontSize: '14',
                            padding: [5,0]
                        },
                        icon: 'rect',
                        itemWidth: 11,
                        itemHeight: 11,
                        formatter: function (name) {
                            let val = '';
                            data.forEach(item => {
                                if(item.name == name) {
                                    val= name +' | '+ (item.value / organizationTotal * 100).toFixed(2)+'%' + ' ' + item.value;
                                }
                            })
                            return val;
                        },
                    },
                    grid: {
                        left: 0
                    },
                    color: PIE_COLOR,
                    series: [
                        {
                            name: '机构类型',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['20%','50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            data: data
                        }
                    ]
                };
                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/common.scss";
    .inner{
        padding:1% 2%;
    }
    .xs{
        &-left,
        &-right{
            width:24.72%;
            height:100%;
            overflow: hidden;
            .chart-con{
                height:calc(100% / 3);
            }
            .chart{
                height:calc(100% - 0.4rem);
            }
        }
        &-center{
            width:47.56%;
            margin:0 1.5%;
            height:100%;
            overflow: hidden;
            .rink-con{
                margin-top:0.23rem;
                height: calc(100% - 0.77rem);
                .estimate_header{
                    span{
                        float:left;
                        height:0.77rem;
                        text-align: center;
                        width:calc(100% / 8);
                        border-right:1px solid #090C26;
                        font-size:0.14rem;
                        line-height: 0.77rem;
                        background: #151d50;
                        &:last-child{
                            border:0;
                        }
                    }
                }
                .estimate_body{
                    height: calc(100% - 0.77rem);
                    overflow-y: hidden;
                    .estimate_box{
                        height: 100%;
                        overflow-y: auto;
                        dl{
                            overflow: hidden;
                            background: #080B26;
                            &:nth-child(2n){
                                background: #141D51;
                            }
                        }
                        dd{
                            float: left;
                            color:#B6C8FF;
                            height:0.86rem;
                            line-height:0.86rem;
                            font-size:0.16rem;
                            text-align: center;
                            width:calc(100% / 8);
                            border:1px solid #090C26;
                            &:first-child{
                                cursor: pointer;
                            }
                            &.active{
                                color:red;
                            }
                        }
                    }
                }
            }
        }
    }
</style>